import { useState } from "react";

export const bindInputValue = (item, info, setInfo) => {
    return (key) => {
        const currentValue =
            (info && Object.prototype.hasOwnProperty.call(info, key)
                ? info[key]
                : item?.[key]) ?? "";
        const onChange = (_evt, data = {}) => {
            const value = data.value ?? "";
            const target = { ...(info || {}) };
            if (!value) {
                delete target[key];
            } else {
                target[key] = value;
            }
            setInfo(target);
        };
        return {
            value: currentValue,
            onChange,
        };
    };
};

export const bindDropdownValue = (item, info, setInfo) => {
    return (key) => {
        let defaultValue = item?.[key] || "全部";
        const onOptionSelect = (_evt, data) => {
            let value = data.optionValue;
            let target = { ...(info || {}) };
            if (!value && !defaultValue) {
                delete target[key];
            } else {
                target[key] = value;
            }
            setInfo(target);
        };
        let defaultSelectedOptions = (info && info[key] && [info[key]]) ||
            (item?.[key] && [item?.[key]]) ||
            [""];
        return {
            defaultValue: "全部",
            defaultSelectedOptions,
            onOptionSelect,
        };
    };
};

export const useInfo = (initialValue = {}) => {
    const [info, setInfo] = useState(initialValue);
    const updateInfo = (kv) => {
        setInfo((prev) => ({ ...(prev || {}), ...kv }));
    };
    return { info, setInfo, updateInfo };
};
